import React from 'react';

import SharedAppList from '../components/SharedApp/SharedAppList';

function SharedAppListPage() {
  return <SharedAppList />;
}

export default SharedAppListPage; 